// WSP labels can contain rich text; extract text without mounting partner HTML.
export const getSurveyDisplayText = (value) => {
  if (!value || !/[<&]/.test(value)) return value;

  const parsedDocument = new DOMParser().parseFromString(value, "text/html");
  parsedDocument
    .querySelectorAll("script, style, template")
    .forEach((node) => node.remove());
  parsedDocument.body.querySelectorAll("br, p, div, li").forEach((node) => {
    node.before(" ");
    node.after(" ");
  });

  return parsedDocument.body.textContent.replace(/\s+/g, " ").trim();
};
